import { ILLCompany, ISSDPConctact } from './index';

export class IImporter {
  importerId: number;
  sequence: number;
  importerCompany: ILLCompany;
  importerContact: ISSDPConctact;
}